/* eslint-disable import/no-extraneous-dependencies */
import './PaymentHistory.scss';

import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';

import { loadPaymentHistory } from 'actions/payments';
import { DateRangeInput } from 'atoms/date-range-input';
import Input from 'atoms/input';
import Table from 'organisms/Table';
import { openDrawer } from 'store/reducers/ui';
import { addDays } from 'util';
import { paymentsColumns, paymentsColumnsOrder } from 'util/constants';

const defaultEndDate = dayjs();
const defaultStartDate = dayjs(addDays(defaultEndDate, -25));

export default function PaymentHistory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [dateRanges, setDateRanges] = useState([
    defaultStartDate,
    defaultEndDate,
  ]);
  const { pages, isLoading } = useSelector((state) => state.paymentHistory);
  const [query, setQuery] = useState(null);

  useEffect(() => {
    const [start, end] = dateRanges;
    if (start && end)
      dispatch(loadPaymentHistory({ page: params.page, range: dateRanges }));
  }, [params.page, dateRanges]);

  const debounceLoadPaymentHistory = useCallback(
    debounce((q) => {
      dispatch(
        loadPaymentHistory({ page: params.page, range: dateRanges, query: q })
      ).then(() => onChangePange(1));
    }, 1000),
    [params.page, dateRanges, dispatch]
  );

  const updateQuery = (q) => {
    setQuery(q);
    debounceLoadPaymentHistory(q);
  };

  const onChangePange = (page) => {
    navigate(`/payment-history/${page}`);
  };

  const onTransactionClick = (item) => {
    dispatch(openDrawer({ type: 'appointment', uuid: item.appointmentUuid }));
  };

  const onDateRangeChange = (range) => {
    const [start, end] = range;
    setDateRanges([start, end]);
    onChangePange(1);
  };

  return (
    <>
      <Helmet title="Payment | PawCare" />
      <div className="w-100 flex-row payment-history h-100">
        <div className="page-container payment-page-container">
          <div className="flex-row justify-between payment-page-container-header pb-20 pt-20 pr-30 pl-30">
            <h1>Payment history</h1>
          </div>
          <div className="flex-row justify-between pb-20 pt-20 pr-30 pl-30 payment-page-container-header">
            <Input
              placeholder="Search client"
              className="client-search-input"
              size="small"
              shape="round"
              variant="white"
              onChange={updateQuery}
              value={query}
              icon="search"
            />
            <DateRangeInput
              onChange={onDateRangeChange}
              dateRanges={dateRanges}
            />
          </div>
          <div className="payment-page-container-table-container table-container pb-20">
            <Table
              items={pages[params.page]?.data}
              isLoading={isLoading}
              onClickRow={onTransactionClick}
              columns={paymentsColumns}
              columnsOrder={paymentsColumnsOrder}
              rowsBgColor
              pagination={pages[params.page]}
              onChangePange={onChangePange}
            />
          </div>
        </div>
      </div>
    </>
  );
}
